// /api/auth 엔드포인트 래퍼.
import { api } from './client';

export interface AuthStatus {
  initialized: boolean;
  unlocked: boolean;
  /** 서버가 본 현재 클라이언트 IP. 디버그/UX용. */
  myIp?: string | null;
  /** 현재 IP가 신뢰 IP 목록에 있는지 — 잠금 화면에서 TOTP 생략 힌트 표시에 사용. */
  myIpIsTrusted?: boolean;
}

export interface InitResult {
  recoveryCode: string;
  totpSecret: string;
  totpOtpauthUri: string;
  totpQrDataUrl: string;
}

/** v2 자동 이관 결과 메타 — 서버 V2MigrationResult와 동일 구조 */
export interface V2MigrationMeta {
  migrated: boolean;
  itemsCount: number;
  groupsCount: number;
  durationMs: number;
  skipReason?: string;
  error?: string;
}

export interface LoginResult {
  isNewIp: boolean;
  trustedIp: boolean;
  /** v2 자동 이관 결과. 이관이 실행된 경우에만 존재. */
  v2Migration?: V2MigrationMeta;
}

export const authApi = {
  status: () => api.get<AuthStatus>('/api/auth/status'),
  init: (password: string) => api.post<InitResult>('/api/auth/init', { password }),
  login: (password: string, totpToken: string) =>
    api.post<LoginResult>('/api/auth/login', { password, totpToken }),
  logout: () => api.post<{ ok: true }>('/api/auth/logout'),
  changePassword: (oldPassword: string, newPassword: string) =>
    api.post<{ ok: true }>('/api/auth/change-password', { oldPassword, newPassword }),
  reset: (recoveryCode: string, newPassword: string) =>
    api.post<{ newRecoveryCode: string }>('/api/auth/reset', { recoveryCode, newPassword }),
  rotateRecovery: () => api.post<{ newRecoveryCode: string }>('/api/auth/rotate-recovery'),
};
